/* eslint-disable no-unused-vars */
export enum RouteNames {
  LOGIN = "/login",
  CALLBACK="/callback",
  DASHBOARD = "/dashboard",
  ATHLETE_LOGIN = "/athlete-login",
  APPROVALS = "/approvals",
  MYACCESS = "/myaccount/myaccess",
  FAMILY = "/myaccount/family",
}
/* eslint-enable no-unused-vars */